module.exports = __webpack_public_path__ + "media/images/flags/gb-nir-8ad03581959bce8c3da0e389104cf1e3.svg";